module.exports = __webpack_public_path__ + "img/img_mianxi02@2x.4b185de8.png";